import React from 'react';
import { gql } from '@common/hooks';
import PropTypes from 'prop-types';
import { Row, Typography } from 'antd';
import { Licenses } from '@clinician-profile/components';
import { SubmittalPacketInfoFragment } from 'works/legacy/graphql/submittal-packet';
import { SubmittalPacketPreviewerDrawerTrigger } from '@applicant-flow/components';

const { Title } = Typography;

export function CandidateProfile({ worksProfile }) {
  const firstSubmittalPacketId = worksProfile.worksSubmittalPackets[0]?.id;

  return (
    <Row className="CandidateProfile candidate-row">
      <section className="candidate-title-section">
        <Title level={4} className="section-title">
          Summary
        </Title>
        <p className="section-body">{worksProfile.profileSummary}</p>
      </section>
      <section className="candidate-sidebar-section">
        <div style={{ marginBottom: 16 }}>
          <Licenses licenses={worksProfile.licenses} />
        </div>
        {worksProfile.worksSubmittalPackets.length > 0 && (
          <SubmittalPacketPreviewerDrawerTrigger
            submittalPacketId={firstSubmittalPacketId}
          />
        )}
      </section>
      <style jsx>{`
        .candidate-title-section {
          flex-grow: 1;
          margin-right: 1rem;
          overflow: auto;
        }
        .candidate-sidebar-section {
          flex-shrink: 0;
        }
        .section-body {
          overflow-wrap: break-word;
        }
      `}</style>
    </Row>
  );
}

CandidateProfile.fragments = {
  worksProfile: gql`
    fragment CandidateProfileWorksProfileFragment on WorksProfile {
      id
      profileSummary
      licenses {
        id
        ...LicensesLicenseFragment
      }
      ...SubmittalPacketFragment
    }
    ${Licenses.fragments.license}
    ${SubmittalPacketInfoFragment}
  `,
};

CandidateProfile.propTypes = {
  worksProfile: PropTypes.shape({
    profileSummary: PropTypes.string,
    worksSubmittalPackets: PropTypes.arrayOf(PropTypes.object),
    licenses: PropTypes.arrayOf(PropTypes.object),
    staffingRequestApplications: PropTypes.arrayOf(PropTypes.object),
  }),
};
